<ng-container *transloco="let t">
  <div class="flex h-full w-full flex-col">
    <div class="mb-4 flex items-center justify-between border-b border-gray-100 pb-4">
      <div class="flex items-center gap-4">
        <div class="flex items-center gap-1.5 text-sm">
          <app-bulk-upload-type-icon [type]="BulkUploadRunStatus.CREATED" />
          <div>
            {{ created().length }}
            <span class="text-gray-500">{{ t("bulk-upload-run.created", [created().length]) }}</span>
          </div>
        </div>
        <div class="flex items-center gap-1.5 text-sm">
          <app-bulk-upload-type-icon [type]="BulkUploadRunStatus.UPDATED" />
          <div>
            {{ updated().length }}
            <span class="text-gray-500">{{ t("bulk-upload-run.updated", [updated().length]) }}</span>
          </div>
        </div>
        @if (failed().length > 0) {
          <div class="flex items-center gap-1.5 text-sm">
            <app-bulk-upload-type-icon [type]="BulkUploadRunStatus.FAILED" />
            <div>
              {{ failed().length }}
              <span class="text-gray-500">{{ t("bulk-upload-run.errors", [failed().length]) }}</span>
            </div>
          </div>
        }
      </div>
      <div>
        <button iButton variant="secondary" (click)="closeImport.emit()">
          {{ t("bulk-upload-run.close_import") }}
        </button>
      </div>
    </div>
    <div class="ag-theme-quartz ag-theme-quartz-light flex-1">
      <ag-grid-angular class="h-full" [gridOptions]="gridOptions()"></ag-grid-angular>
    </div>
  </div>
</ng-container>
